{
    "status": {
        "due": "Fällig",
        "overdue": "Überfällig",
        "completed": "Abgeschlossen"
    },
    "blankAnswer": "Nicht ausgefüllt",
    "list": {
        "title": "Tagebücher",
        "emptyTitle": "Noch keine Tagebücher",
        "emptyDescription": "Für Sie angelegte Tagebücher erscheinen hier",
        "checkAgain": "Erneut prüfen",
        "needsAttention": "Erfordert Ihre Aufmerksamkeit",
        "needsAttentionDesc": "Tagebücher mit Formularen, die auf Ihren nächsten Eintrag warten.",
        "upToDate": "Aktuell",
        "ongoing": "Laufend",
        "ongoingDesc": "Tagebücher, die laufen oder auf Ihren ersten Eintrag warten.",
        "upToDateDesc": "Laufende Tagebücher ohne fällige Einträge.",
        "noOngoing": "Derzeit keine laufenden Tagebücher",
        "completed": "Abgeschlossen",
        "completedDesc": "Tagebücher, die beendet sind (es werden keine weiteren Einträge erfasst).",
        "noCompleted": "Noch keine abgeschlossenen Tagebücher",
        "openDiary": "Tagebuch öffnen",
        "reviewDiary": "Tagebuch ansehen"
    },
    "goToDiaries": {
        "title": "Zu {{diaryWord}}",
        "actionRequiredCount": "Aktion erforderlich ({{count}})",
        "actionRequiredOneForm": "Aktion erforderlich ({{count}} Formular)",
        "actionRequiredManyForms": "Aktion erforderlich ({{count}} Formulare)",
        "defaultDescription": "Tagebücher sind Ihre persönlichen Gesundheitsprotokolle und helfen, Behandlung und Forschung zu verbessern.",
        "oneFormDue": "Sie haben {{count}} Formular, das ausgefüllt werden muss.",
        "manyFormsDue": "Sie haben {{count}} Formulare, die ausgefüllt werden müssen.",
        "diariesNeedAttention": "Sie haben {{count}} {{diaryWord}} mit Formularen, die Ihre Aufmerksamkeit erfordern."
    }
}
